import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import CourseImage from '../examples/CourseImage';
import CourseImageFinished from '../examples/CourseImageFinished';
const CourseImageSource = require('!!raw-loader!../examples/CourseImage');
const CourseImageFinishedCourse = require('!!raw-loader!../examples/CourseImageFinished');
export default class CourseImagePage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Course Image"/>
                <h3>Course Image</h3>
                <div className="docs-example">
                    <div className="docs-image-wrapper">
                        <CourseImage />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CourseImageSource}</PrismCode>
                </pre>
                <div>
                    <h4>Course Image Properties</h4>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`
CourseImage.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    srcSet: PropTypes.string,
    sizes: PropTypes.string,
    className: PropTypes.string,
    isFinished: PropTypes.bool,
};
`}
                        </PrismCode>
                    </pre>
                </div>
                <h3>Course Image Finished</h3>
                <div className="docs-example d-flex">
                    <div className="docs-image-wrapper mr-5">
                        <CourseImageFinished />
                    </div>
                    <div className="docs-image-wrapper--small">
                        <CourseImageFinished />
                    </div>
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CourseImageFinishedCourse}</PrismCode>
                </pre>
            </div>);
    }
}
